import React, { useState, useEffect } from "react";
import "./style.css";
import API from "../../utils/API";
import cogoToast from "@successtar/cogo-toast";

function UploadDocWidget({ refreshVault, id, policyType }) {
  const [formData, setFormData] = useState({
    fileName: "",
    fileData: ""
  });

  useEffect(() => {
    console.log("Upload Document Widget mounted!");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const triggerRefresh = (newDocID) => {
    console.log("Refreshing Vault after successful upload");
    refreshVault(newDocID);
  };

  const getBase64 = (file, callBack) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      callBack(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
      return error;
    };
  };

  const fileSelectedHandler = (event) => {
    event.preventDefault();
    console.log(event.target.files);

    setFormData((prev) => ({
      ...prev,
      fileName: event.target.files[0].name
    }));

    if (event.target.files[0]) {
      getBase64(event.target.files[0], (res) => {
        console.log(res);
        setFormData((prev) => ({
          ...prev,
          fileData: res
        }));
      });
    }
  };

  const handleFileUpload = (event) => {
    event.preventDefault();

    const fileInformation = {
      policyid: id,
      type: policyType.toLowerCase(),
      document: formData.fileData,
      docName: formData.fileName
    };

    console.log("Creating Document:");
    console.log(fileInformation);

    switch (policyType.toLowerCase()) {
      case "property":
        console.log("Adding Document to Policy of Type: " + policyType);
        API.createDocumentForProperty(id, fileInformation)
          .then((res) => {
            console.log(res.data);
            cogoToast.success("Uploaded Property Document!");
            triggerRefresh(res.data._id);
          })
          .catch((err) => {
            cogoToast.error("Error uploading policy");
            console.log(err);
          });
        break;
      case "auto":
        console.log("Adding Document to Policy of Type: " + policyType);
        API.createDocumentForAuto(id, fileInformation)
          .then((res) => {
            console.log(res.data);
            cogoToast.success("Uploaded Auto Document!");
            triggerRefresh(res.data._id);
          })
          .catch((err) => {
            cogoToast.error("Error uploading document");
            console.log(err);
          });
        break;
      case "umbrella":
        console.log("Adding Document to Policy of Type: " + policyType);
        API.createDocumentForUmbrella(id, fileInformation)
          .then((res) => {
            console.log(res.data);
            cogoToast.success("Uploaded Umbrella Document!");
            triggerRefresh(res.data._id);
          })
          .catch((err) => {
            cogoToast.error("Error uploading document");
            console.log(err);
          });
        break;
      case "client":
        console.log("Adding Document for Policy of Type: " + policyType);
        API.createDocumentForClient(id, fileInformation)
          .then((res) => {
            console.log(res.data);
            cogoToast.success("Uploaded Client Document!");
            triggerRefresh(res.data._id);
          })
          .catch((err) => {
            cogoToast.error("Error uploading document");
            console.log(err);
          });
        break;
      case "agent":
        console.log("Adding Document for Policy of Type: " + policyType);
        API.createDocumentForAgent(id, fileInformation)
          .then((res) => {
            console.log(res.data);
            cogoToast.success("Uploaded Agent Document!");
            triggerRefresh(res.data._id);
          })
          .catch((err) => {
            cogoToast.error("Error uploading document");
            console.log(err);
          });
        break;
      case "quote":
        console.log("Adding Document for Policy of Type: " + policyType);
        API.createDocumentForQuote(id, fileInformation)
          .then((res) => {
            console.log(res.data);
            cogoToast.success("Uploaded Quote Document!");
            triggerRefresh(res.data._id);
          })
          .catch((err) => {
            cogoToast.error("Error uploading document");
            console.log(err);
          });
        break;
      case "servicerequest":
        console.log("Adding Document for Policy of Type: " + policyType);
        API.createDocumentForServiceRequest(id, fileInformation)
          .then((res) => {
            console.log(res.data);
            cogoToast.success("Uploaded Service Request Document!");
            triggerRefresh(res.data._id);
          })
          .catch((err) => {
            cogoToast.error("Error uploading document");
            console.log(err);
          });
        break;
      case "vehicle":
        console.log("Adding Document for Policy of Type: " + policyType);
        API.createDocumentForVehicle(id, fileInformation)
          .then((res) => {
            console.log(res.data);
            cogoToast.success("Uploaded Vehicle Document!");
            triggerRefresh(res.data._id);
          })
          .catch((err) => {
            cogoToast.error("Error uploading document");
            console.log(err);
          });
        break;
      case "referral":
        console.log("Adding Document for Policy of Type: " + policyType);
        API.createDocumentForReferral(id, fileInformation)
          .then((res) => {
            console.log(res.data);
            cogoToast.success("Uploaded Referral Document!");
            triggerRefresh(res.data._id);
          })
          .catch((err) => {
            cogoToast.error("Error uploading document");
            console.log(err);
          });
        break;
      case "contact":
        console.log("Adding Document for Policy of Type: " + policyType);
        API.createDocumentForContact(id, fileInformation)
          .then((res) => {
            console.log(res.data);
            cogoToast.success("Uploaded Contact Document!");
            triggerRefresh(res.data._id);
          })
          .catch((err) => {
            cogoToast.error("Error uploading document");
            console.log(err);
          });
        break;
      case "driver":
        console.log("Adding Document for Policy of Type: " + policyType);
        API.createDocumentForDriver(id, fileInformation)
          .then((res) => {
            console.log(res.data);
            cogoToast.success("Uploaded Driver Document!");
            triggerRefresh(res.data._id);
          })
          .catch((err) => {
            cogoToast.error("Error uploading document");
            console.log(err);
          });
        break;
      case "license":
        console.log("Adding Document for Policy of Type: " + policyType);
        API.createDocumentForLicense(id, fileInformation)
          .then((res) => {
            console.log(res.data);
            cogoToast.success("Uploaded License Document!");
            triggerRefresh(res.data._id);
          })
          .catch((err) => {
            cogoToast.error("Error uploading document");
            console.log(err);
          });
        break;
      case "application":
        console.log("Adding Document for Policy of Type: " + policyType);
        API.createDocumentForApplication(id, fileInformation)
          .then((res) => {
            console.log(res.data);
            cogoToast.success("Uploaded Application Document!");
            triggerRefresh(res.data._id);
          })
          .catch((err) => {
            cogoToast.error("Error uploading document");
            console.log(err);
          });
        break;
      case "enrollment":
        console.log("Adding Document for Policy of Type: " + policyType);
        API.createDocumentForEnrollment(id, fileInformation)
          .then((res) => {
            console.log(res.data);
            cogoToast.success("Uploaded Enrollment Document!");
            triggerRefresh(res.data._id);
          })
          .catch((err) => {
            cogoToast.error("Error uploading document");
            console.log(err);
          });
        break;
      default:
        console.log("Didn't recognize Policy type: " + policyType);
        break;
    }
  };

  return (
    <div style={{ maxWidth: "100%", border: "solid" }}>
      <div style={{ padding: "10px" }}>
        <br />
        <h5 className="card-text">Upload File to Vault:</h5>
        <br />
        <input name="fileData1" type="file" onChange={fileSelectedHandler} />
        <br />
        <button
          style={{ backgroundColor: "transparent", border: "solid" }}
          onClick={handleFileUpload}
        >
          Submit
        </button>
        <br />
      </div>
    </div>
  );
}

export default UploadDocWidget;
